// @flow

import type { PropsSchema, EasyAction, BasicProps } from '../../type'

import * as React from 'react'
import cx from 'classnames'
import onClickEvents from '../hoc/onClickEvent'
import computeData from '../hoc/computeData'
import css from './AppText.scss'

type Props = BasicProps & {
  id: string,
  style: { [string]: string },
  value: string,
  children: React.ChildrenArray<React.Node>,
  onClick: () => void,
  numberOfLines?: number
};

@computeData({ includeData: true })
@onClickEvents
export default class AppText extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      key: 'value',
      title: '内容',
      type: 'textarea'
    },
    {
      key: 'numberOfLines',
      title: '行数',
      type: 'number'
    },
    'separator',
    {
      type: 'style',
      group: 'text'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '数据绑定',
      name: 'bindData'
    }
  ];

  render () {
    if (!this.props.visible) {
      return null
    }
    const {
      id,
      style,
      value = '',
      onClick,
      children,
      jsEnv,
      numberOfLines
    } = this.props

    if (typeof style.lineHeight === 'number') {
      // RN lineHeight 只支持 number
      style.lineHeight += 'px'
    }

    return (
      <span
        onClick={onClick}
        style={style}
        id={id}
        className={cx(numberOfLines && css.ellipsis)}
      >
        {jsEnv.getString(value)}
        {children}
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/app/AppText.js